var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50Z",
    fill: "#0080B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0625 26.5L54.1562 58.3438H47.1875L46.2812 26.5H55.0625ZM46.0312 68.1562C46.0312 66.9271 46.4479 65.8958 47.2812 65.0625C48.1354 64.2083 49.2812 63.7812 50.7188 63.7812C52.1562 63.7812 53.2917 64.2083 54.125 65.0625C54.9792 65.8958 55.4062 66.9271 55.4062 68.1562C55.4062 69.3646 54.9792 70.3854 54.125 71.2188C53.2917 72.0521 52.1562 72.4688 50.7188 72.4688C49.2812 72.4688 48.1354 72.0521 47.2812 71.2188C46.4479 70.3854 46.0312 69.3646 46.0312 68.1562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/no_data_available.0247d60d1c45500a2ded7f4909e01e61.svg";
export { ForwardRef as ReactComponent };